import { MuiThemeProvider } from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import { AppState, BaseApplicationState } from "../../store";
import { InnerAppFrame, InnerAppFrameOwnProps } from "./app-frame/InnerAppFrame";

interface AppFrameStateProps {
  appState: AppState;
}

type AppFrameProps = AppFrameStateProps & InnerAppFrameOwnProps;

export const AppFrameComponent = (props: AppFrameProps) => {
  const { appState, ...rest } = props;
  const { theme } = appState;

  return (
    <MuiThemeProvider theme={theme}>
      <InnerAppFrame {...rest} />
    </MuiThemeProvider>
  );
};

export const AppFrame = connect<AppFrameStateProps, {}, InnerAppFrameOwnProps, BaseApplicationState>(state => {
  return {
    appState: state.app,
  };
})(AppFrameComponent);
